import React from "react";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";
import PrivateRoute from "../../../../layout/PrivateRoute";
import BillingDetails from "./BillingDetails";
import BillingPaymentMethod from "./BillingPaymentMethod";

interface Props extends RouteComponentProps<{}> {}

const BillingPage: React.FC<Props> = ({ match }) => {
  return (
    <div className="flex flex-col w-full h-full">
      <Switch>
        <PrivateRoute
          path={`${match.path}/details`}
          component={BillingDetails}
        />

        <PrivateRoute
          path={`${match.path}/payment-method`}
          component={BillingPaymentMethod}
        />

        <Redirect to={`${match.path}/details`} />
      </Switch>
    </div>
  );
};

export default BillingPage;
